// src/components/steps/AcademicInfo.js
import React from "react";
import { Form, Button, Space, Divider } from "antd";
import AcademicRecordItem from "../AcademicRecordItem";
import { PlusOutlined, MinusCircleOutlined } from "@ant-design/icons";

/**
 * AcademicInfo Step
 * - Renders Form.List for academic_records
 * - Allows adding/removing records dynamically
 * - Each record reuses AcademicRecordItem component
 */
export default function AcademicInfo() {
  return (
    <Form.List name="academic_records" initialValue={[{}]}>
      {(fields, { add, remove }) => (
        <>
          {fields.map((field, index) => (
            <div
              key={field.key}
              style={{
                marginBottom: 24,
                padding: 16,
                border: "1px solid #f0f0f0",
                borderRadius: 8,
                background: "#fafafa",
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginBottom: 12,
                }}
              >
                <h4 style={{ margin: 0, color: "#111827" }}>
                  Academic Record #{index + 1}
                </h4>
                {fields.length > 1 && (
                  <Button
                    type="text"
                    danger
                    icon={<MinusCircleOutlined />}
                    onClick={() => remove(field.name)}
                    aria-label={`Remove record ${index + 1}`}
                  >
                    Remove
                  </Button>
                )}
              </div>

              {/* Reuse your AcademicRecordItem for the actual form fields */}
              <AcademicRecordItem field={field} />

              {index < fields.length - 1 && <Divider />}
            </div>
          ))}

          {/* Add New Record Button */}
          <Form.Item>
            <Button
              type="dashed"
              onClick={() => add()}
              block
              icon={<PlusOutlined />}
            >
              Add Academic Record
            </Button>
          </Form.Item>
        </>
      )}
    </Form.List>
  );
}
